import { render, staticRenderFns } from "./detailCase.vue?vue&type=template&id=e085ebca&scoped=true"
import script from "./detailCase.vue?vue&type=script&lang=js"
export * from "./detailCase.vue?vue&type=script&lang=js"
import style0 from "./detailCase.vue?vue&type=style&index=0&id=e085ebca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e085ebca",
  null
  
)

export default component.exports